import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";



import { MdDeveloperMode,MdContactPage } from "react-icons/md";


import Wrapper from "./Home/Wrappe";
import { Toogle } from "../Context/Tooglebutton";



function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
   

    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
      style={{
        width: "100%"
      }}
    >
      
      <Container className="navcontanier">
        <Navbar.Brand href="" target="_blank">
          <MdDeveloperMode style={{ marginBottom: "2px" }} /> Ritik Gupta
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" defaultActiveKey="#home">
          
          
            <Nav.Item>
             <a href="#home" style={{
               color:"white"
             }} onClick={() => updateExpanded(false)} > Home</a>
            </Nav.Item>
           

            <Nav.Item>
            <a href="#about"  style={{
               color:"white"
             }}onClick={() => updateExpanded(false)} > About</a>
            </Nav.Item>
         
            <Nav.Item>
            <a href="#skill" style={{
               color:"white"
             }} onClick={() => updateExpanded(false)} > Skills</a>
            </Nav.Item>

            <Nav.Item>
             <a href="#project" style={{
               color:"white"
             }} onClick={() => updateExpanded(false)} > Projects</a>
            </Nav.Item>
         
            <Nav.Item>
            <a href="#contact" style={{
               color:"white"
             }} onClick={() => updateExpanded(false)} > Contact Us</a>
            </Nav.Item>
            <Nav.Item>
               <a style={{
               color:"white"
              }} href="https://drive.google.com/file/d/1vBkv_pCSdByi4qHZRosF9kITdad2AhG5/view?usp=sharing"  onClick={() => updateExpanded(false)}   target="_blank"> Resume</a>
            </Nav.Item>
            <Nav.Item id="tooglebtn">
              <Toogle/>
            </Nav.Item>
        
            
          </Nav>
        </Navbar.Collapse>
      </Container>
      <div className="scrolling-buttons">
        <Wrapper>
       
        </Wrapper>
      </div>
    </Navbar>

  );
}

export default NavBar;
